import React, { useState, useRef } from "react";

const PixCopiaCola = ({ qrData }) => {
    const [showPixPayload, setShowPixPayload] = useState(false);
    const [copyMessage, setCopyMessage] = useState('');
    const textAreaRef = useRef(null);

    const handleTogglePixPayload = () => {
        setShowPixPayload(!showPixPayload);
    };

    const handleCopyPixPayload = () => {
        if (textAreaRef.current) {
            textAreaRef.current.select();
            document.execCommand('copy');
            setCopyMessage("Payload copiado para a área de transferência!");
            setTimeout(() => setCopyMessage(''), 3000); // Limpa a mensagem após 3 segundos
        } else {
            setCopyMessage("Falha ao copiar o payload.");
            setTimeout(() => setCopyMessage(''), 3000); // Limpa a mensagem após 3 segundos
        }
    };

    return (
        <div className="pix-copia-e-cola">
            <div className="pix-payload-toggle">
                <label>
                    <input
                        type="checkbox"
                        checked={showPixPayload}
                        onChange={handleTogglePixPayload}
                    />
                    Exibir Pix Copia e Cola
                </label>
            </div>
            {showPixPayload && (
                <div className="pix-payload">
                    <textarea
                        ref={textAreaRef}
                        value={qrData}
                        readOnly
                        style={{ position: 'absolute', left: '-9999px' }}
                    />
                    <pre>{qrData}</pre>
                    <button className="btn-copy" onClick={handleCopyPixPayload}>
                        Copiar
                    </button>
                    {copyMessage && <div className="copy-message">{copyMessage}</div>}
                </div>
            )}
        </div>
    );
};

export default PixCopiaCola;